export default __webpack_public_path__ + "static/media/navlogo (2).625dbd27.png";